import React from "react";

import TripPromotionForm from "./TripPromotionForm";

const AddPromotion = () => <TripPromotionForm />;

export default AddPromotion;
